import { LinkIcon } from '@blocksuite/affine-components/icons';

import type { DenseMenuBuilder } from '../common/type.js';

export const buildLinkDenseMenu: DenseMenuBuilder = edgeless => ({
  type: 'action',
  name: 'Link',
  icon: LinkIcon,
  select: () => {
    const { insertedLinkType } = edgeless.std.command.exec(
      'insertLinkByQuickSearch'
    );

    insertedLinkType
      ?.then(type => {
        if (type) {
          if (type.isNewDoc) {
            edgeless.service.telemetryService?.track('doc_created', {
              control: 'toolbar:general',
              page: 'whiteboard editor',
              module: 'edgeless toolbar',
              type: type.flavour?.split(':')[1],
            });
          }
        }
      })
      .catch(console.error);
  },
});
